export default __webpack_public_path__ + "static/media/image-1.011c7f33.jpg";